import config from 'constants/apiConfig';
import axios from 'axios';

type Base64PdfString = string;

export type ExportPlannedResourceAsFormParams = {
  walaId: string;
  plannedResourceId: string;
  periodNumber?: number;
};

export const ICS_204A_FORM_NAME = 'ICS_204A_CG';

export async function postExportPlannedResourceAsForm(
  periodNumber: number,
  { walaId, plannedResourceId }: ExportPlannedResourceAsFormParams
): Promise<{ formName: string; data: string }> {
  const response = await axios.post<Base64PdfString>(
    `${config.apiGateway.ics_planned_resource}/${plannedResourceId}/export`,
    {
      walaId,
      periodNumber,
      skipWorkspaceUpload: true,
    }
  );
  return { formName: ICS_204A_FORM_NAME, data: response.data || '' };
}
